import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

interface GetCustomerResponse {
    customer_idx: number;
    customer_name: string;
}

export const useGetOrderCustomer = (searchtxt?: string, customer_idx?:number): UseQueryResult<GetCustomerResponse[], Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetCustomerResponse[], Error>({
        queryKey: ["getOrderCustomer", searchtxt, customer_idx],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_order_customer}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: {
                    search: "customer_name",
                    searchtxt,
                    customer_idx,
                },
            });
            return response.data.data;
        },
    });
};
